
import $ from "jquery";
import {checkNested, getConfig } from "../../scripts/general_functions.js";
import breadcrumb from './breadcrumb';
import dayjs from "dayjs";
import language from "../../scripts/translation";

import {doSearch} from "../../scripts/search.js";

export default function(val) {
    
    let searchOn = $.trim(val);
    const breadcrumbHtml = breadcrumb();
    
    document.title = "Søk";
    
    doSearch(searchOn);
    
    return `
        <div class="container">
            ${breadcrumbHtml}
        </div>
        <div class="container">
          <div class="row no-gutters" style="">
              <!--div class="container"-->
                  <div class="searchheader">
                      <div class="container">
                          <div class="row no-gutters">
                              <h4 class="searchheader__input-title">Søk</h4>
                              <!--div class="xcol-12 xcol-sm-6 xcol-sm-offset-3 xoffset-sm-3"-->
                                  <div class="searchheader__input-group" role="search">
                                    <input type="search" class="form-control searchheader__inputfield" id="searchheader__inputfield" placeholder="${language("SEARCH_INPUT")}" value="">
                                    <span class="input-group-btn">
                                      <button class="btn btn-default searchheader__search-button" id="searchheader__button" type="button">
                                          <span class="searchheader__buttonicon budlight-search"></span>
                                      </button>
                                    </span>
                                  </div>
                              <!--/div-->
                          </div>
                      </div>
                  </div>
                  <div class="row searchcontent no-gutters">
                      <div class="col-12 col-md-3" id="leftCol" style="display:none;">
                        <div class="categories">
                          <div class="categories__header">
                            <h2 class="categories__headertitle">
                              <a href="#" class="categories__headerlink">${language("SEARCH_FILTERHEADER")}</a>
                            </h2>
                          </div>
                          <div class="categories__selected"></div>
                          <div class="categories__list">
                            <div class="categories__collection"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-9" id="mainCol">
                          <div class="searchresult__header">
                              <div class="searchresult__meta">
                                  <div class="row">
                                      <div class="col-12 col-md-8">
                                          <div id="resultscount" class="searchresult__meta__count"></div>
                                      </div>
                                      <div class="col-12 col-md-4 no-gutters">
                                          <div class="dropdown searchresult__meta__dropdown__container">
                                              <label class="searchresult__meta__label">${language("SEARCH_SORTBY")}</label>
                                              <div class="searchresult__meta__dropdown">
                                                <button class="btn btn-default dropdown-toggle pull-right searchresult__meta__dropdown-button" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                    <span class="btn-text searchresult__meta__choosedtxt">${language("SEARCH_RELEVANCE")}</span>
                                                    <span class="icon budlight-chevron-bottom"></span>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-right searchresult__meta__dropdown-content" aria-labelledby="dropdownMenu1">
                                                    <li><a href="#" data-order="Relevance" class="searchresult__meta__choice dropdown-item">${language("SEARCH_RELEVANCE")}</a></li>
                                                    <li><a href="#" data-order="Date" class="searchresult__meta__choice dropdown-item">${language("SEARCH_DATE")}</a></li>
                                                </ul>
                                              </div>
                                          </div>

                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="searchresult">
                          
                              <div class="lds-ellipsis black"><div></div><div></div><div></div><div></div></div>
                              <div class="searchresult__filter"></div>
                              <div class="">
                                  <div class="searchresult__list list-unstyled"></div>
                              </div>
                              <div class="searchresult__footer"><div class="searchresult__pagination"></div></div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>`;
}
